import React from 'react';
import cn from 'classnames';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import CustomControl from '../../components/CustomControl/CustomControl';

const EditingModal = ({
  config,
  customTitles,
  hasTableEditingModalOpen,
  allGroups,
  isPendingColumnHidden,
  togglePendingColumnVisibility,
  handleCancelChanges,
  applyColumnChanges,
}) => {
  return (
    <Modal
      backdrop="static"
      isOpen={hasTableEditingModalOpen}
      toggle={handleCancelChanges}
      centered
      autoFocus
      className="modal-lg editing-modal"
    >
      <ModalHeader toggle={handleCancelChanges}>
        <FormattedMessage
          id="statistics.editing-modal.title"
          defaultMessage="Редактировать таблицу"
        />
      </ModalHeader>

      <ModalBody>
        {allGroups.map((groupTitle) => {
          const groupColumns = config.filter((column) => {
            if (column.isRendering === false) return false;

            const groupId = column.group || '__EMPTY__';
            let currentGroupTitle = groupId;

            if (customTitles && customTitles[groupId]) {
              currentGroupTitle = customTitles[groupId];
            }

            return currentGroupTitle === groupTitle;
          });

          if (groupColumns.length === 0) return null;

          return (
            <FormGroup className="editing-modal-form-group" key={groupTitle}>
              {groupTitle !== '__EMPTY__' && <p className="editing-modal-title">{groupTitle}</p>}
              {groupColumns.map((column) => {
                const isHidden = isPendingColumnHidden(column.id);

                return (
                  <CustomControl
                    key={column.id}
                    id={column.id}
                    name={column.title + column.id}
                    className={cn('custom-checkbox-eye', {
                      'custom-checkbox-eye--hidden': isHidden,
                    })}
                    onChange={() => togglePendingColumnVisibility(column.id)}
                    checked={!isHidden}
                    type="checkbox"
                    value={Number(!isHidden)}
                  >
                    {column.title}
                  </CustomControl>
                );
              })}
            </FormGroup>
          );
        })}
      </ModalBody>

      <ModalFooter>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelChanges}
        >
          <FormattedMessage id="statistics.editing-modal.btn-cancel" defaultMessage="Отмена" />
        </button>
        <button type="button" className="btn btn-primary" onClick={applyColumnChanges}>
          <FormattedMessage id="statistics.editing-modal.btn-save" defaultMessage="Сохранить" />
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default EditingModal;
